var map = {
	"./appstore.svg": "6848",
	"./aquathlon.svg": "5667",
	"./arrow-left.svg": "d704",
	"./arrow-right.svg": "9e2e",
	"./atmark.svg": "75bc",
	"./badge.svg": "601c",
	"./basketball.svg": "4f36",
	"./beach-volleyball.svg": "d968",
	"./bell.svg": "e358",
	"./biathlon.svg": "cf61",
	"./calendar.svg": "dc29",
	"./camera.svg": "0ca2",
	"./chat-bubble.svg": "3320",
	"./check-bold.svg": "1c95",
	"./check-circle-s.svg": "3a26",
	"./check-circle.svg": "bdcf",
	"./climbing.svg": "15df",
	"./clock.svg": "1458",
	"./close-circle-s.svg": "3fa6",
	"./close.svg": "d866",
	"./code.svg": "af45",
	"./compass.svg": "a42c",
	"./connect.svg": "2ef3",
	"./copy.svg": "0490",
	"./cross-country-skiing.svg": "4149",
	"./crown.svg": "eab0",
	"./cycling.svg": "8495",
	"./delete.svg": "d0c6",
	"./dog-paw.svg": "83ea",
	"./down.svg": "8597",
	"./duathlon.svg": "ce1f",
	"./edit.svg": "c7e6",
	"./empty-flag.svg": "7945",
	"./environment.svg": "8889",
	"./exclamation-circle-s.svg": "29a5",
	"./exclamation-circle.svg": "325c",
	"./export.svg": "3e01",
	"./externa-link.svg": "cb38",
	"./eye-invisible.svg": "65b2",
	"./eye.svg": "b476",
	"./feedback.svg": "28d5",
	"./female.svg": "de9c",
	"./file-done.svg": "b0f4",
	"./fitness-tracker.svg": "4581",
	"./geolocation.svg": "3049",
	"./gift.svg": "8165",
	"./global.svg": "c5e7",
	"./goal.svg": "1f10",
	"./gymnastics.svg": "a1cb",
	"./heart.svg": "ec04",
	"./history.svg": "ca13",
	"./hourglass.svg": "d77a",
	"./info-circle-s.svg": "c3a1",
	"./info-circle.svg": "b686",
	"./invite.svg": "b93c",
	"./left.svg": "d6d3",
	"./loading-3-quarters.svg": "1fe0",
	"./mail.svg": "c6b2",
	"./male.svg": "2a7a",
	"./minus.svg": "e747",
	"./more-horizontal.svg": "4b4f",
	"./more-vertical.svg": "23c5",
	"./mountain.svg": "4a7e",
	"./participation.svg": "3c3d",
	"./partnerlink.svg": "7cc6",
	"./play.svg": "40c8",
	"./plus.svg": "521e",
	"./pulse.svg": "a0ec",
	"./question.svg": "bc0e",
	"./quiz.svg": "4740",
	"./read.svg": "6497",
	"./registration.svg": "d35b",
	"./rocket.svg": "6f39",
	"./running.svg": "b8e5",
	"./safety-float.svg": "ae75",
	"./search.svg": "e96c",
	"./send-clock.svg": "6dab",
	"./settings.svg": "8462",
	"./shopping-bag.svg": "c4a5",
	"./skiing.svg": "1ecfc",
	"./smartphone.svg": "af404",
	"./snowboarding.svg": "212d",
	"./soccer.svg": "11f7",
	"./solution.svg": "edf0",
	"./star.svg": "a956",
	"./steps.svg": "f366",
	"./stopwatch.svg": "1d2f",
	"./survey.svg": "6586",
	"./swimming.svg": "c560",
	"./sync.svg": "57c9",
	"./table-tennis.svg": "c322",
	"./team.svg": "58c3",
	"./telegram.svg": "a580",
	"./tennis.svg": "8778",
	"./time-limit.svg": "d889",
	"./timer.svg": "384d",
	"./track-and-field.svg": "6cf5",
	"./triathlon.svg": "783a",
	"./trophy.svg": "e739",
	"./up.svg": "b3db",
	"./upload.svg": "96cc",
	"./uploadimage.svg": "0ead",
	"./user-edit.svg": "ddfa",
	"./user-groups.svg": "ab28",
	"./user.svg": "a1e4",
	"./vk.svg": "e183",
	"./walking.svg": "b5a1",
	"./warning-s.svg": "1158",
	"./warning.svg": "01e9",
	"./wellbeing.svg": "0cc8",
	"./windsurfing.svg": "249c"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ec0d";